import {UserStore} from './UserStore';
import {AuthStore} from './AuthStore/AuthStore';
import {ConferenceStore} from './ConferenceStore';
import {ChatStore} from './ChatStore';
import {ClassStore, ClassStoreType} from './ClassStore';
import {CreateClassStore, ICreateClassStore} from './CreateClassStore';
import {AnalyticsStore} from './AnalyticsStore';
import {ClassMetaDataStore} from './ClassMetaDataStore';
import {PopUpStore} from './PopUpStore';
import {LoaderStore} from './LoaderStore';
import {AdminGeneralStore} from './AdminGeneralStore';
import {AdminTeachersStore} from './AdminTeachersStore';
import {AdminGroupsStore} from './AdminGroupsStore';
import {AdminGroupsStudentsStore} from './AdminGroupStudentsStore';

export interface RootStoreType {
  authStore: AuthStore;
  userStore: UserStore;
  conferenceStore: ConferenceStore;
  chatStore: ChatStore;
  classStore: ClassStore;
  createClassStore: CreateClassStore;
  analyticsStore: AnalyticsStore;
  classMetaDataStore: ClassMetaDataStore;
  popUpStore: PopUpStore;
  loaderStore: LoaderStore;
  adminGeneralStore: AdminGeneralStore;
  adminTeachersStore: AdminTeachersStore;
  adminGroupsStore: AdminGroupsStore;
}

export class RootStore {
  authStore: AuthStore;
  userStore: UserStore;
  conferenceStore: ConferenceStore;
  classStore: ClassStoreType;
  createClassStore: ICreateClassStore;
  classMetaDataStore: ClassMetaDataStore;
  analyticsStore: AnalyticsStore;
  popUpStore: PopUpStore;
  loaderStore: LoaderStore;
  adminGeneralStore: AdminGeneralStore;
  adminTeachersStore: AdminTeachersStore;
  adminGroupsStore: AdminGroupsStore;
  adminGroupsStudentsStore: AdminGroupsStudentsStore;

  constructor() {
    this.loaderStore = new LoaderStore();
    this.popUpStore = new PopUpStore();
    this.userStore = new UserStore(this.popUpStore, this.loaderStore);
    this.authStore = new AuthStore(this.userStore);
    this.classStore = new ClassStore(this.popUpStore);
    this.conferenceStore = new ConferenceStore(
      this.userStore,
      this.loaderStore,
      this.popUpStore,
    );
    this.analyticsStore = new AnalyticsStore(this, this.loaderStore);
    this.classMetaDataStore = new ClassMetaDataStore(this);
    this.createClassStore = new CreateClassStore(this.loaderStore);
    this.adminGeneralStore = new AdminGeneralStore(this);
    this.adminTeachersStore = new AdminTeachersStore(this);
    this.adminGroupsStore = new AdminGroupsStore(this);
    this.adminGroupsStudentsStore = new AdminGroupsStudentsStore(
      this,
      this.adminGroupsStore,
    );
  }
}
